export default function profiling(result, action, options = {}) {
    options.logger?.trace(action);
    if (result.profiling) {
        result.profiling.push({
            action,
            time: Date.now() - options.start,
        });
    }
}
//# sourceMappingURL=profiling.js.map